import { Mail, MapPin, Linkedin, Github, Globe } from 'lucide-react';
import { Resume } from '../../types';

interface HeroSectionProps {
  personalInfo: Resume['personalInfo'];
}

export default function HeroSection({ personalInfo }: HeroSectionProps) {
  return (
    <section className="border-b border-gray-200 bg-gradient-to-br from-primary-50 to-white py-16 dark:border-gray-800 dark:from-primary-950 dark:to-gray-900">
      <div className="container">
        <div className="flex flex-col items-center text-center md:flex-row md:text-left">
          <div className="mb-6 md:mb-0 md:mr-8">
            <div className="h-32 w-32 overflow-hidden rounded-full p-1 shadow-lg" style={{ background: 'linear-gradient(135deg, #f5f5f5 0%, #ffffff 25%, #e8e8e8 50%, #ffffff 75%, #f0f0f0 100%)' }}>
              <img 
                src="https://assets.rathor.dev/ravindra.png" 
                alt={personalInfo.name}
                className="h-full w-full rounded-full object-cover object-top"
              />
            </div>
          </div>
          
          <div className="flex-1">
            <h1 className="mb-2 text-4xl font-bold text-gray-900 dark:text-gray-50">{personalInfo.name}</h1>
            <p className="mb-4 text-xl text-gray-600 dark:text-gray-400">{personalInfo.title}</p>
            
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-600 md:justify-start dark:text-gray-400">
              <a href={`mailto:${personalInfo.email}`} className="flex items-center gap-1 hover:text-primary-600 dark:hover:text-primary-400">
                <Mail size={16} />
                {personalInfo.email}
              </a>
              <span className="flex items-center gap-1">
                <MapPin size={16} />
                {personalInfo.location}
              </span>
            </div>
            
            <div className="mt-4 flex items-center justify-center gap-3 md:justify-start">
              <a
                href={personalInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-lg bg-white p-2 shadow-sm transition-all hover:shadow-md dark:bg-gray-800"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} className="text-primary-600 dark:text-primary-400" />
              </a>
              <a
                href={personalInfo.github}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-lg bg-white p-2 shadow-sm transition-all hover:shadow-md dark:bg-gray-800"
                aria-label="GitHub"
              >
                <Github size={20} className="text-gray-900 dark:text-gray-100" />
              </a>
              <a
                href={personalInfo.website}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-lg bg-white p-2 shadow-sm transition-all hover:shadow-md dark:bg-gray-800"
                aria-label="Website"
              >
                <Globe size={20} className="text-primary-600 dark:text-primary-400" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
